import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import StickyTourCTA from "@/components/site/StickyTourCTA";
import FloatingContact from "@/components/site/FloatingContact";
import ScrollToTop from "@/components/site/ScrollToTop";

import HomePage from "@/pages/Home";
import AvailableSpaces from "@/pages/AvailableSpaces";
import SpaceDetail from "@/pages/SpaceDetail";
import AmenitiesPage from "@/pages/Amenities";
import LocationPage from "@/pages/Location";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";
import IndustriesPage from "@/pages/Industries";
import NicheLandingPage from "@/pages/NicheLandingPage";
import I75Landing from "@/pages/landing/I75Landing";
import { SEO_LANDINGS } from "@/data/seoLandings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/available-spaces" element={<AvailableSpaces />} />
            <Route path="/spaces/:slug" element={<SpaceDetail />} />
            <Route path="/amenities" element={<AmenitiesPage />} />
            <Route path="/location" element={<LocationPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/office-space-near-i-75-weston" element={<I75Landing />} />
            {SEO_LANDINGS.map((l) => (
              <Route
                key={l.slug}
                path={`/${l.slug}`}
                element={
                  <NicheLandingPage
                    slug={l.slug}
                    metaTitle={l.metaTitle}
                    metaDescription={l.metaDescription}
                    h1={l.h1}
                    intro={l.intro}
                    audience={l.audience}
                    benefits={l.benefits}
                    recommendedSlugs={l.recommendedSlugs}
                    heroImage={l.heroImage}
                    defaultOfficeType={l.defaultOfficeType}
                  />
                }
              />
            ))}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <StickyTourCTA />
        <FloatingContact />
        <Toaster position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
